import { ApplicationConfig, isDevMode, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withPreloading } from '@angular/router';

import { routes } from './app.routes';
import { provideServiceWorker } from '@angular/service-worker';
import { provideQuillConfig } from 'ngx-quill/config';

import { NativeDateAdapter } from '@angular/material/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_NATIVE_DATE_FORMATS, provideNativeDateAdapter } from '@angular/material/core'; // ### jackie add
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { CustomDateAdapter, CustomPreloadingStrategy } from 'jk-service';

/*
export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    return `${year}/${this.pad(month)}/${this.pad(day)}`;
  }

  private pad(n: number): string {
    return ('00' + n).slice(-2);
  }
}*/

import { utilApiAuthInterceptor } from './security/util-api-auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),// 🔥 新增 zoneless 支援
    //provideRouter(routes),
    provideRouter(routes, withPreloading(CustomPreloadingStrategy)),// ### jackie add
    //provideAnimationsAsync(),
    provideNativeDateAdapter(),// ### jackie add
    { provide: DateAdapter, useClass: CustomDateAdapter, deps: [MAT_DATE_LOCALE] }, // ### jackie add
    { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'zh-TW' },

    provideQuillConfig({ // ### jackie add
      modules: {
        syntax: true,
        toolbar: [
          ['bold', 'italic', 'underline', 'link'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['clean'],
        ],
      }
    }),
    provideHttpClient(withFetch(), withInterceptors([utilApiAuthInterceptor])), // 添加 withFetch() 以支援 keepalive 選項
    provideServiceWorker('ngsw-worker.js', { // ### jackie add
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    // Lazy loading services
    CustomPreloadingStrategy
  ]
};

